import React, { Component } from "react";
import * as XLSX from 'xlsx'; // Import the xlsx library

//Import Breadcrumb

//Constants
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
  Fn_GetReport,
} from "../../store/functions";

import Select from "react-select";
function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const day = String(currentDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
class Excel_LedgerWiseBill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFormData: {},
      formData: { PaymentType: 0 },
      PaymentType: [
        { Id: 1, Name: "Cash" },
        { Id: 2, Name: "Credit" },
        { Id: 3, Name: "Bank" },
      ],
      FromDate: getCurrentDate(),
      ToDate: getCurrentDate(),
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      SearchKeyArray: [],
      currentPage: 1,
      rowsPerPage: 20,
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Group";
    this.modalTitle = "Group Details";
    this.rtPage_Add = "AddGroup";
    this.rtPage_Edit = "EditGroup";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/Ledger";
    this.API_URL1 = API_WEB_URLS.MASTER + "/0/token/ExcelLedgerWise";
    this.API_URL_SAVE = API_WEB_URLS.ExcelPurCompany + "/0/token";
    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);

    this.handleItemChange = this.handleItemChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handleDateChange (event){
    const {value,name} = event.target;
    this.setState({
      [name]:value
    })
  }
  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
    });
    Fn_FillListData(this.obj, "Companies", this.API_URL + "/Id/0");
  }
  handleItemChange(option) {
    console.log(option.value);
    console.log(option.label);

    let F_CompanyMaster = option.value;
    this.setState({
      F_CompanyMaster,
    });
  }
  btnSave_onClick(event, formData) {
    const obj = JSON.parse(sessionStorage.getItem("authUser"));

    


    if (!this.state.F_CompanyMaster) {
      this.setState({
        FromDate : formData.FromDate ,
        ToDate : formData.ToDate
      })
      alert('Please select an Ledger');
     
      return;
  }
  Fn_FillListData(this.obj, "gridData", this.API_URL1 + "/Id/"+ this.state.F_CompanyMaster);

  }

  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }
  btnEdit_onClick(formData) {
    this.props.history.push(`${this.rtPage_Edit}/${formData.Id}`, {});
  }
  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  btnExportToExcel = () => {
    const { gridData } = this.state;
    const worksheet = XLSX.utils.json_to_sheet(gridData.map(item => ({
      VoucherNo: item.VoucherNo,
      VoucherDate: item.VoucherDate,
      Name: item.Name,
      NetAmount: item.NetAmount,
      NetAmountInWords: item.NetAmountInWords,
    }))); // Map gridData to match table structure
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "GridData");

    // Calculate totals
    const totalNetAmount = gridData.reduce((acc, item) => acc + Number(item.NetAmount), 0).toFixed(2); // Calculate total net amount

    // Add total row
    const totalRow = {
        VoucherNo: "Total",
        VoucherDate: "",
        Name: "",
        NetAmount: totalNetAmount,
        NetAmountInWords: "",
    };

    // Add a line row before the total row
    const lineRow = {
        VoucherNo: "----------------",
        VoucherDate: "----------------",
        Name: "----------------",
        NetAmount: "----------------",
        NetAmountInWords: "----------------",
    };
    XLSX.utils.sheet_add_json(worksheet, [lineRow], { skipHeader: true, origin: -1 });

    XLSX.utils.sheet_add_json(worksheet, [totalRow], { skipHeader: true, origin: -1 });

    XLSX.writeFile(workbook, "GridData.xlsx");
  };

  render() {
    const { currentPage, rowsPerPage, gridData } = this.state;
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = gridData.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(gridData.length / rowsPerPage);

    const totalNetAmount = currentRows.reduce((acc, item) => acc + Number(item.NetAmount), 0).toFixed(2); // Calculate total net amount

    return (
      <div className="page-content">
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="wizard clearfix">
                  <div className="content clearfix">
                    <AvForm
                      className="needs-validation"
                      onValidSubmit={this.btnSave_onClick}
                    >
                      <Row>
                        <Col sm="1" className="mb-3">
                          <label
                            htmlFor="Company"
                            className="col-form-label"
                          >
                            {" "}
                            Ledger
                          </label>
                        </Col>
                        <Col sm="3">
                          <Select
                            options={
                              this.state.Companies &&
                              this.state.Companies.map(item => ({
                                value: item.Id,
                                label: item.Name,
                              }))
                            }
                            onChange={this.handleItemChange}
                            placeholder="Search or select Item"
                            isSearchable
                          />
                        </Col>
{/* 
                        <Col sm="1" className="mb-3">
                          <label htmlFor="tilldatee" className="col-form-label">
                            {" "}
                            From Date
                          </label>
                        </Col>
                        <Col sm="3" className="mb-3">
                          <AvField
                            name="FromDate"
                            label=""
                            value={
                              this.state.FromDate == undefined
                                ? getCurrentDate()
                                : this.state.FromDate
                            }
                            placeholder="From Date"
                            errorMessage="Select Date "
                            validate={{ required: { value: true } }}
                            onChange={this.handleDateChange}
                            type="date"
                            className="form-control"
                          />
                        </Col>
                        <Col sm="1" className="mb-3">
                          <label htmlFor="To Date" className="col-form-label">
                            {" "}
                            To Date
                          </label>
                        </Col>
                        <Col sm="3" className="mb-3">
                          <AvField
                            name="ToDate"
                            label=""
                            value={
                              this.state.ToDate == undefined
                                ? getCurrentDate()
                                : this.state.ToDate
                            }
                            placeholder="From ToDate"
                            errorMessage="Select ToDate "
                            validate={{ required: { value: true } }}
                            onChange={this.handleDateChange}
                            type="date"
                            className="form-control"
                          />
                        </Col> */}

                        <Col sm="3" className="mb-3">
                          <Button
                            type="submit"
                            color="primary"
                            className="mr-1 waves-effect waves-light"
                          >
                            {" "}
                            View{" "}
                          </Button>
                        </Col>
                        {gridData.length > 0 && (
                          <Col sm="3" className="mb-3">
                            <Button
                              type="button"
                              color="success"
                              onClick={this.btnExportToExcel}
                              className="mr-1 waves-effect waves-light"
                            >
                              {" "}
                              Export to Excel{" "}
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </AvForm>
                    {/* New Table for gridData */}
                    <table className="table table-bordered mt-4">
                      <thead>
                        <tr>
                        <th>Voucher No</th>
              <th>Voucher Date</th>
              <th>Name</th>
              <th>Net Amount</th>
              <th>Net Amount In Words</th>
                       
                        </tr>
                      </thead>
                      <tbody>
                        {currentRows.map((item, index) => (
                          <tr key={index}>
                          <td>{item.VoucherNo}</td>
                <td>{item.VoucherDate}</td>
                <td>{item.Name}</td>
                <td>{item.NetAmount}</td>
                <td>{item.NetAmountInWords}</td>
                          </tr>
                        ))}
                        <tr>
                        <td colSpan="3" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</td>
              <td style={{ fontWeight: 'bold' }}>{totalNetAmount}</td>
              <td></td>
                        </tr>
                      </tbody>
                    </table>
                    {/* Pagination Controls */}
                    <div className="pagination">
                      <button
                        onClick={() => this.handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        &lt; {/* Arrow Back */}
                      </button>
                      {currentPage > 1 && (
                        <button onClick={() => this.handlePageChange(1)}>1</button>
                      )}
                      {currentPage > 3 && <span>...</span>}
                      {Array.from({ length: Math.min(5, totalPages) }, (_, index) => {
                        const pageNumber = Math.max(2, currentPage - 2) + index;
                        return (
                          pageNumber <= totalPages && (
                            <button
                              key={pageNumber}
                              onClick={() => this.handlePageChange(pageNumber)}
                              disabled={currentPage === pageNumber}
                            >
                              {pageNumber}
                            </button>
                          )
                        );
                      })}
                      {currentPage < totalPages - 2 && <span>...</span>}
                      {currentPage < totalPages && (
                        <button onClick={() => this.handlePageChange(totalPages)}>
                          {totalPages}
                        </button>
                      )}
                      <button
                        onClick={() => this.handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        &gt; {/* Arrow Forward */}
                      </button>
                    </div>
                    {/* End of Pagination Controls */}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
export default compose(container)(Excel_LedgerWiseBill);
